export enum TokenTypes {
  ACCESS_TOKEN = ".accessToken",
  ID_TOKEN = ".idToken",
  REFRESH_TOKEN = ".refreshToken",
}

export enum CookieConfig {
  baseReference = "CognitoIdentityServiceProvider.",
}
